var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "call-center",
  transform: "translate(-31)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4767",
  "data-name": "Path 4767",
  d: "M33.4,19.253h2.4v1.6h1.6V9.653H35.8v1.6H34.2v-.8a8.8,8.8,0,1,1,17.6,0v.8H50.2v-1.6H48.6v11.2h1.6v-1.6h1.6v2.4a2.449,2.449,0,0,1-2.4,2.453H45.253a2.4,2.4,0,1,0,0,1.6H49.4a4.051,4.051,0,0,0,4-4.053V19.106A2.4,2.4,0,0,0,55,16.853v-3.2A2.4,2.4,0,0,0,53.4,11.4v-.947a10.4,10.4,0,1,0-20.8,0V11.4A2.4,2.4,0,0,0,31,13.653v3.2A2.4,2.4,0,0,0,33.4,19.253Z",
  fill: "#fff"
}));
function SvgCallCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.307,
    viewBox: "0 0 24 27.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/call-center.e261cd8244feb35fa3683dc6d2297936.svg";
export { ForwardRef as ReactComponent };